import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import ShawPen from './pages/ShawPen';
import VanderCook from './pages/VanderCook';
import HeidelBerg from './pages/Heidelberg';
import LinoType from './pages/LinoType';

class App extends Component {

  componentDidMount(){
  
  }


  render() {

    return (
      <div className="App">
        <Router>
          <div>
            <Route exact path="/" component={Home} />
            <Route path="/shaw" component={ShawPen} />
            <Route path="/vandercook" component={VanderCook} />
            <Route path="/heidelberg" component={HeidelBerg} />
            <Route path="/linoType" component={LinoType} />
            
          
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js